import 'css/app.css';
import 'scss/app.scss';
import 'stylus/app.styl';

// Utilities
import Log from './_Utility/Log';

// Core
import MonthPicker from './MonthPicker';
import ReView from './ReView';
import EventPopup from './EventPopup';
import Attendees from './Attendees';
import AttendeeExport from './AttendeeExport';
import Map from './Map';

// Vendors
import 'bootstrap4-toggle/css/bootstrap4-toggle.min.css';
import 'bootstrap4-toggle';
import CodeScanner from './_Vendors/CodeScanner';
import Woo from './_Vendors/Woo';

(function($)
{
    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function()
    {
        // Let the frontend know we are cooking
        new Log('P3 Events is ready.', 'success');

        // Core initialization
        new MonthPicker();
        new EventPopup();
        new Attendees();
        new AttendeeExport();
        new Map();

        // Vendor initialization
        new CodeScanner();
        new Woo();
    });

})(jQuery);